import { TickIcon } from 'styles/assets/icons';
import { Box } from 'UIKit';

import styles from './mandatoryDeclarationModal.module.scss';

const SelectedLabel = ({
  optionId,
  selectedId,
}: {
  optionId: string;
  selectedId: string;
}) => {
  return (
    <Box className={styles.selectedOption}>
      <Box as="span">{optionId}</Box>
      {optionId === selectedId && <TickIcon className={styles.tickIcon} />}
    </Box>
  );
};

export default SelectedLabel;
